export enum ComparisonEnum {
  Table = 'TABLE',
  Graph = 'GRAPH',
  Time = 'TIME',
}
